<template>
  <v-chart ref="chartBar" class="chart" :option="option" autoresize />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import VChart from "vue-echarts";
import { reactive, getCurrentInstance, watch } from "vue-demi";

use([CanvasRenderer, PieChart, TooltipComponent]);

export default {
  components: {
    VChart,
  },
  provide: {},
  props: {
    statusList: { type: Object, default: {} },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;
    const option = reactive({
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
        textStyle: {
          fontFamily: "DBHelvethaicaX45Li",
          fontSize: 20,
        },
      },
      textStyle: {
        fontFamily: "DBHelvethaicaX45Li",
        fontSize: 24,
      },
      series: [
        {
          name: "Status",
          type: "pie",
          radius: ["50%", "90%"],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 1,
          },
          label: {
            show: true,
            formatter: "{d}%",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "26",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data: [],
        },
      ],
    });

    watch(props.statusList, () => {
      vm.$refs.chartBar.setOption({
        series: [
          {
            data: [
              {
                value: props.statusList.success,
                name: "Complete",
                itemStyle: { color: "#00c965" },
              },
              {
                value: props.statusList.pending,
                name: "Pending",
                itemStyle: { color: "#ffce00" },
              },
              {
                value: props.statusList.reject,
                name: "Rejected",
                itemStyle: { color: "#e33c3c" },
              },
            ],
          },
        ],
      });
    });
    return {
      option,
    };
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 220px;
}
</style>
